import React, { useEffect, useRef, useState } from "react";
import FormHeading from "../../../Components/FormComponents/FormHeading";
import StepButtons from "../../../Components/FormComponents/StepButtons";
import { Text4 } from "../../../Components/FormComponents/InputFields";
import { useForm } from "react-hook-form";
import { Button, Col, message, Modal, notification, Row } from "antd";
import { SubmitNomineeApi } from "../../../Services/EmployeeOnboarding";
import { useNavigate, useOutletContext } from "react-router-dom";
import { getNomineeColumnsConfig } from "./Component/ComlumnConfig";
import CustomEditableTable from "./Component/IdentityTable";
import { RiEyeCloseFill, RiEyeCloseLine } from "react-icons/ri";
import PdfModal from "./Component/pdfModel";
import axios from "axios";
import ApproveReject from "./Component/ApproveReject";

const defaultRelations = [{ label: 1 }];

export default function Nominee({ current, setCurrent }) {
  const { control, handleSubmit, reset } = useForm();

  const [api, contextHolder] = notification.useNotification();
  const [isError, setIsError] = useState(false);
  const [isFinalModal, setIsFinalModal] = useState(false);
  const [loading, setLoading] = useState({ final: false, submit: false });
  const [isAgreed, setIsAgreed] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const { responseData, id } = useOutletContext();
  const [isUpdate, setIsUpdate] = useState(false)
  const type = sessionStorage.getItem("userType");

  const handleCheckboxChange = () => {
    setIsChecked((prev) => !prev);
  };

  const { dropDowns } = useOutletContext();
  const relationshipdrop = (dropDowns && dropDowns.RELATIONSHIP) || [];

  const navigate = useNavigate(null);
  const [output, setOutput] = useState(null);
  const [tableData, setTableData] = useState(defaultRelations);

  const counter = useRef(0);

  function generateSimpleId() {
    return (
      "id-" +
      (counter.current++).toString(36) +
      "-" +
      Math.random().toString(36).slice(2, 5)
    );
  }

  const handleAddRow = () => {
    setTableData((prev) => [
      ...prev,
      {
        label: generateSimpleId(),
      },
    ]);
  };

  const handleRemoveRow = (labelToRemove) => {
    setTableData((prev) => prev.filter((row) => row.label !== labelToRemove));
  };

  const handleChangeValue = (value, field, relation) => {
    setOutput((prev) => ({
      ...prev,
      [relation]: {
        ...prev?.[relation],
        [field]: value,
      },
    }));
  };
  const nomineecolumnsConfig = getNomineeColumnsConfig(
    handleChangeValue,
    relationshipdrop
  );

  const onSubmit = async (val) => {
    console.log(output, "checing sdfasd");
    setLoading((prev) => ({
      ...prev,
      submit: true,
    }));
    if (!output)
      return api.error({
        message: "Please Fill Nominee Detail",
        placement: "top",
      });

    const nomineeDetail = Object.values(output);

    try {
      const { data } = await SubmitNomineeApi(nomineeDetail);
      setLoading((prev) => ({
        ...prev,
        submit: false,
      }));
      console.log("Bank details submitted:", data);
      console.log();
      if (data?.success) {
        if(isUpdate) {
           api.success({
            message: data?.message,
            placement: "top",
          });
           setIsUpdate(false)
          return
         
          // navigate(`/admin/employees-verification/${id}/offer-letter`);
        }
        if (isAgreed) {
          // navigate("/new-user/offer-letter");
          // api.success({
          //   message: data?.message,
          //   placement: "top",
          // });
          if (responseData?.final_submit) {
            handleSubmitFinal();
          } else {
            setIsFinalModal(true);
          }
        } else {
          api.error({
            message: "Please Agree to the Terms and Conditions",
            placement: "top",
          });
        }
      } else {
        api.error({
          message: data?.message,
          placement: "top",
        });

        throw new Error(
          "Submission failed: " + (data?.message || "Unknown error")
        );
      }
    } catch (error) {
      console.error("Error submitting bank details:", error);
    }
  };

  const pdfUrl = "/pdf/tnc.pdf";

  async function sendTermPdfFile() {
    try {
      if (!isChecked) {
        setIsError({
          message: "Please Check Terms And Condition",
        });
        return;
      }
      const response = await fetch(pdfUrl);
      const blob = await response.blob();

      const formData = new FormData();
      formData.append("file", blob, "tnc.pdf");
      formData.append("i_agree", isChecked);

      const { data } = await axios.post(
        "/api/employees/employee-tnc",
        formData
      );

      if (data?.success) {
        setIsOpen(false);
        getTermAgreed();
        return api.success({
          message: data?.message,
          placement: "top",
        });
      } else {
        return api.error({
          message: data?.message,
          placement: "top",
        });
      }
    } catch (error) {
      console.error("Error sending PDF file:", error);
    }
  }
  const getTermAgreed = async () => {
    const { data } = await axios.get("/api/employees/employee-tnc");
    console.log(data, "checcking data");
    setIsAgreed(data?.i_agree);
  };

  const getNomineeDetail = async (responseData) => {
    console.log(responseData, "responseData from nominee");
    setOutput((prev) => {
      const updated = { ...prev };
      responseData?.nominees?.forEach((item, index) => {
        updated[index + 1] = {
          ...item,
        };
      });
      return updated;
    });
  };

  const getEmployeeDetail = async () => {
    getNomineeDetail(responseData);
    if (type !== "admin") {
      getTermAgreed();
    } else {
      setIsAgreed(responseData?.tnc_agreed);
    }
  };

  const is_Final_submit =
    responseData?.final_submit?.nominees_meta?.final_submit;

  const is_approve = responseData?.final_submit?.nominees_meta?.is_approved;

  const handleSubmitFinal = async () => {
    setLoading((prev) => ({ ...prev, final: true }));

    const { data } = await axios.post("/api/employees/final-submit", {
      final_submit: true,
    });

    if (data?.success) {
      api.success({
        message: data?.message,
        placement: "top",
      });
      navigate("/new-user/offer-letter");
    } else {
      api.error({
        message: data?.message,
        placement: "top",
      });
    }

    console.log("hellow");
  };

  useEffect(() => {
    getEmployeeDetail();
  }, [reset, responseData]);

  return (
    <>
      {contextHolder}
      <form
        className="responsive-form h-full"
        onSubmit={handleSubmit(onSubmit)}
      >
        <Row className="align-content-start  w-full ">
        
            
              <Col className="flex justify-between" span={24}> 
                               <h2 className="color-heading">Nominee Details (for PF & ESIC)</h2>
                      
                                   {isUpdate &&  <Button onClick={()=>setIsUpdate(false)}  style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center'
                                    }} shape="circle" icon={ <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x-lg" viewBox="0 0 16 16">
                                        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"/>
                                      </svg> }> 
                               </Button>||  <Button onClick={()=>setIsUpdate(true)}  style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center'
                                    }} shape="circle" icon={<svg  xmlns="http://www.w3.org/2000/svg" width="16"  fill="currentColor" className="bi bi-pencil-fill m-auto " viewBox="0 0 16 16">
                                    <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z"/>
                                  </svg>}> 
                               </Button> }
                              
                                </Col>
      
          <div className=" w-full mb-4 mt-4 ml-2">
            <CustomEditableTable
              handleAddRow={handleAddRow}
              handleRemoveRow={handleRemoveRow}
              columnsConfig={nomineecolumnsConfig}
              tableData={tableData}
              setTableData={setTableData}
              setOutput={setOutput}
              output={output}
            />
          </div>

          <div>
            <h3 className="color-heading mt-4 mb-3">
              Declaration by the Employee & Candidate Declaration (Pre-joining)
            </h3>

            <div>
              <div className="flex">
                <button
                  disabled={isAgreed}
                  type="button"
                  onClick={() => setIsOpen(true)}
                  className="bg-[#00a0e4] self-center mb-5 mt-4 text-white px-3 py-1 rounded flex items-center"
                >
                  <span className="mr-2 ">
                    <svg
                      width="14"
                      height="9"
                      viewBox="0 0 14 9"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M14 4.5C14 4.2309 13.8451 4.0542 13.5352 3.70073C12.4019 2.40761 9.90182 0 6.99998 0C4.09813 0 1.59816 2.40761 0.464715 3.70073C0.154905 4.0542 0 4.2309 0 4.5C0 4.7691 0.154905 4.9458 0.464715 5.29927C1.59816 6.59242 4.09813 9 6.99998 9C9.90182 9 12.4019 6.59242 13.5352 5.29927C13.8451 4.9458 14 4.7691 14 4.5ZM6.99998 6.75C8.32244 6.75 9.39443 5.74267 9.39443 4.5C9.39443 3.25732 8.32244 2.25 6.99998 2.25C5.67761 2.25 4.60555 3.25732 4.60555 4.5C4.60555 5.74267 5.67761 6.75 6.99998 6.75Z"
                        fill="white"
                      />
                    </svg>
                  </span>{" "}
                  Terms & Conditions
                </button>
                <div className="self-center ml-3">
                  <p className="text-green-500 font-bold text-md">
                    {isAgreed && "Agreed"}
                  </p>
                </div>
              </div>
            </div>
            <PdfModal
              isOpen={isOpen}
              title="Terms & Conditions"
              onClose={() => setIsOpen(false)}
              pdfUrl={pdfUrl}
            >
              {type !== "admin" && (
                <div className=" justify-between items-center">
                  <label className="flex items-center justify-end pt-3 text-sm text-gray-700">
                    <input
                      type="checkbox"
                      className="mr-2  mt-1 self-start"
                      checked={isChecked}
                      onChange={handleCheckboxChange}
                    />
                    <div className="self-start">
                      <div>
                        I have read and agree to all the above terms and
                        conditions.
                      </div>
                      {!isChecked && (
                        <div className="text-red-500 text-left">
                          {" "}
                          {isError && isError?.message}
                        </div>
                      )}
                    </div>
                  </label>

                  <button
                    onClick={sendTermPdfFile}
                    className="m-2 text-white  pl-3 pr-3 custom-primary-btn"
                    type="submit"
                  >
                    Agree
                  </button>
                </div>
              )}
            </PdfModal>
          </div>
          {/* <Col className={`px-3 mb-4 text-justify`} span={24}>
            <h2 class="text-[#00a0e4] font-bold text-xl flex items-center">
              <span class="w-1 h-full bg-[#00a0e4] mr-2">|</span>
              Annexures
            </h2>
          </Col>
          <button
            type="button"
            className="bg-[#00a0e4] text-white px-3 py-1 rounded flex items-center"
          >
            <i className="mr-1">📄</i> Read
          </button> */}
        </Row>

        <Row className="step-buttons-box justify-content-end pt-3 px-2">
          {type !== "admin" && (
            <div>
              {" "}
              {(is_Final_submit === true && (
                <button
                  disabled={true}
                  className="m-2 text-white step-button"
                  type="submit"
                >
                  {loading?.submit ? "Submitting..." : "Submit"}
                </button>
              )) || (
                <button
                  disabled={loading?.submit}
                  className="m-2 text-white step-button"
                  type="submit"
                >
                  {loading?.submit ? "Submitting..." : "Submit"}
                </button>
              )}
            </div>
          ) || <>{isUpdate &&   <button
                  className="m-2 text-white step-button"
                  type="submit"
                >
                  {loading?.submit ? "Updating..." : "Update"}
                </button>}{" "
                }</> }
        </Row>
      </form>
      {type === "admin" && is_Final_submit &&(
        <>
          {is_approve !== true && (
            <ApproveReject
              id={id}
              redirect="offer-letter"
              detailType={["nominees"]}
            />
          )}
        </>
      )}{" "}
      <Modal
        title="Are you sure you want to submit your data for HR review?"
        open={isFinalModal}
        onCancel={() => setIsFinalModal(false)}
        width="600px"
        footer={[
          <Button key="cancel" onClick={() => setIsFinalModal(false)}>
            Cancel
          </Button>,
          <Button
            type="success"
            className="bg-green-500 text-white"
            onClick={handleSubmitFinal}
            loading={loading?.final}
          >
            Submit
          </Button>,
        ]}
      />
    </>
  );
}
